var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.36963,
    width: 21.9111,
    height: 13.7813,
    rx: 1.5,
    fill: "#949EAB",
    stroke: "#949EAB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86856 16.3914H13.303L13.6725 17.8695H8.49902L8.86856 16.3914Z",
    fill: "#949EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8333 3.83333C11.8333 3.3731 11.4602 3 11 3C10.5398 3 10.1667 3.3731 10.1667 3.83333V7.16667H6.83333C6.3731 7.16667 6 7.53976 6 8C6 8.46024 6.3731 8.83333 6.83333 8.83333H10.1667V12.1667C10.1667 12.6269 10.5398 13 11 13C11.4602 13 11.8333 12.6269 11.8333 12.1667V8.83333H15.1667C15.6269 8.83333 16 8.46024 16 8C16 7.53976 15.6269 7.16667 15.1667 7.16667H11.8333V3.83333Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsLogo);
export default __webpack_public_path__ + "static/media/WHS_Logo.ac677bf5a2c939812eb185d4f2ad20e1.svg";
export { ForwardRef as ReactComponent };